module.exports = __webpack_public_path__ + "static/media/qr_line.0220ea0f.png";